import * as React from "react";
const SvgBurgerMenuLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 5a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2zm0 6a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm1 7a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h16a1 1 0 0 0 1-1", clipRule: "evenodd" }));
export default SvgBurgerMenuLine;
